"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _usageTrackerContainer = require("usage-tracker-container");

var getUsageTracker = function getUsageTracker() {
  try {
    return (0, _usageTrackerContainer.getPrimaryTracker)();
  } catch (err) {
    return {
      track: function track() {
        throw new Error('UsageTracker .track called before setPrimaryTracker');
      }
    };
  }
};

getUsageTracker.track = function () {
  throw new Error('Invalid usage of tracker: Call getUsageTracker().track(), not getUsageTracker.track()');
};

var _default = getUsageTracker;
exports.default = _default;
module.exports = exports.default;